import React from "react";
import { Check } from "lucide-react";
import { cn } from "@/lib/utils";

/**
 * Carte de choix QCM. Sélection nette en un seul tap.
 */
export const QCMChoiceCard = ({
    label,
    subtitle,
    selected = false,
    onClick,
    className,
    dataTestId = "qcm-choice",
}) => {
    return (
        <button
            type="button"
            onClick={onClick}
            aria-pressed={selected}
            data-testid={dataTestId}
            className={cn(
                "tap-feedback w-full min-h-[56px] p-4 rounded-xl text-left",
                "flex items-center justify-between gap-3 select-none",
                "transition-colors duration-150",
                selected
                    ? "bg-ink-800 border-2 border-revred"
                    : "bg-ink-900 border border-ink-700 active:border-revtext-secondary",
                className,
            )}
        >
            <div className="flex flex-col">
                <span
                    className={cn(
                        "text-base text-white",
                        selected ? "font-semibold" : "font-medium",
                    )}
                >
                    {label}
                </span>
                {subtitle ? (
                    <span className="text-sm text-revtext-secondary">{subtitle}</span>
                ) : null}
            </div>
            <span
                className={cn(
                    "shrink-0 w-6 h-6 rounded-full flex items-center justify-center border",
                    selected
                        ? "bg-revred border-revred"
                        : "border-ink-700 bg-transparent",
                )}
            >
                {selected ? <Check size={16} strokeWidth={3} className="text-white" /> : null}
            </span>
        </button>
    );
};
